// firebase.js
import { initializeApp } from "firebase/app";

// const firebaseConfig = {
//   apiKey: 'AIzaSyC6BKwgrMWSiG1dh8VDwM8NJrLhMTud1rE',
//   authDomain: 'crm-app-50829.firebaseapp.com',
//   databaseURL: 'https://project-id.firebaseio.com',
//   projectId: 'crm-app-50829',
//   storageBucket: 'crm-app-50829.appspot.app',
//   messagingSenderId: '707991735493',
//   appId: '1:707991735493:web:940292f08094f7d4dab4ac',
// };

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

export const app = initializeApp(firebaseConfig);
